import api from "../../../services/api";

export default function LayoutPreview({ jobId }) {
  return (
    <div className="mt-3 text-center">
      <img
        src={api.getLayoutingSheetPreview(jobId)}
        style={{
          width: "600px",
          height: "400px",
          objectFit: "contain",
        }}
        alt="preview"
      />
    </div>
  );
}
